module.exports = __webpack_public_path__ + "static/media/group1.ab5e9430.jpg";